import { createSelector as ormSelector } from "redux-orm/lib/redux";
import { createSelector } from 'reselect'
import orm from "../../models";
import { getCurrentEmployment } from "../employments";
import getEntities from "../entities";
import { getScopeAttributes } from "../scoped_entities";


export const getInvoiceConfigurations = ormSelector(orm, getEntities, (session) => {
  return session.invoiceConfiguration.all().toModelArray().map(conf => {
    const { ref } = conf
    return { ...ref,
      ...getScopeAttributes(conf.scopeId, conf.scopeType, session)
    }
  })
})
